"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _colors = _interopRequireDefault(require("../../colors"));

var _Badge = _interopRequireDefault(require("../Badge/Badge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var styles = function styles(theme) {
  return {
    tabsIndicator: {
      backgroundColor: _colors["default"].brand_1
    },
    tabRoot: {
      minWidth: 48,
      fontWeight: 500,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      marginRight: 4,
      backgroundColor: '#FFFFFF',
      fontFamily: 'proxima-soft, sans-seriff',
      '&:hover': {
        color: _colors["default"].brand_1,
        opacity: 1
      },
      '&$tabSelected': {
        backgroundColor: '#FFFFFF',
        color: _colors["default"].brand_1
      }
    },
    tabSelected: {
      borderBottom: "2px solid ".concat(_colors["default"].brand_1)
    }
  };
};

var ViewTabs = function ViewTabs(_ref) {
  var tabs = _ref.tabs,
      activeTabView = _ref.activeTabView,
      handleTabChange = _ref.handleTabChange,
      props = _objectWithoutProperties(_ref, ["tabs", "activeTabView", "handleTabChange"]);

  var classes = props.classes;
  return _react["default"].createElement(_core.Tabs, {
    value: activeTabView,
    onChange: function onChange(event, value) {
      return handleTabChange(value);
    },
    classes: {
      root: classes.tabsRoot,
      indicator: classes.tabsIndicator
    }
  }, tabs.map(function (tab, index) {
    return _react["default"].createElement(_core.Tab, {
      key: index,
      classes: {
        root: classes.tabRoot,
        selected: props.classes.tabSelected
      },
      value: tab.value,
      label: _react["default"].createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, _react["default"].createElement("span", null, tab.label), tab.badgeCount && tab.badgeCount > 0 && _react["default"].createElement(_Badge["default"], {
        count: tab.badgeCount,
        style: {
          marginLeft: 8
        }
      }))
    });
  }));
};

ViewTabs.propTypes = {
  tabs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string,
    badgeCount: _propTypes["default"].number
  })),
  activeTabView: _propTypes["default"].string,
  handleTabChange: _propTypes["default"].func
};

var _default = (0, _styles.withStyles)(styles)(ViewTabs);

exports["default"] = _default;